import { render, staticRenderFns } from "./Murais.vue?vue&type=template&id=851cb06e&"
import script from "./Murais.vue?vue&type=script&lang=js&"
export * from "./Murais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports